import React, {PropTypes} from 'react';
import './shipperInfo.less'
import Rating from '../../components/rating/rating';
import CONSTANTS from '../../common_constants';
import MediaQuery from 'react-responsive';
import moment from 'moment';
import ConfirmDeleteComponent from '../../components/confirm_box/confirm_box';
import {Link, browserHistory} from 'react-router';

class MessageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubmit : false,
      answer : undefined,
      ajaxInProgress : false,
      showConfirmBox : false,
      flagQuestionDetail : ""
    }
  }
  showSubmit = () =>{
    this.setState({
      showSubmit : !this.state.showSubmit,
      answer : undefined
    })
  }
  changeHandler = (e) =>{
    this.setState({
      answer : e.target.value
    })
  }
  answerQuestion = () =>{
    this.setState({
        ajaxInProgress : true
    })
    let paramObj = {
      answer: this.state.answer,
      questionId: this.props.quesAns.questionId,
      shipmentId: this.props.quesAns.shipmentId
    }
    this.props.shipmentActions.answerAQuestion(paramObj).then(() => {
      this.setState({ajaxInProgress: false, error: ''});
    }, (errorRes) => {
      if (errorRes.error === CONSTANTS.sessionInvalid) {
        this.setState({ajaxInProgress: false});
        props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
    });
  }
  hideConfirmBox = () =>{
    this.setState({
      showConfirmBox : false
    })
  }
  showConfirmBox = (questionId) =>{
    this.setState({
      showConfirmBox : true,
      flagQuestionDetail : questionId
    })
  }
  flagQuestion = () =>{
    let paramObj = {
      questionId : this.state.flagQuestionDetail
    }
    this.setState({
      isLoading : true
    })
    this.props.shipmentActions.flagAQuestion(paramObj).then(() => {
      this.setState({isLoading: false, error: ''});
    }, (errorRes) => {
      if (errorRes.error === CONSTANTS.sessionInvalid) {
        this.setState({isLoading: false});
        props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
    });
  }
  render() {
    const {info ,quesAns , userId} = this.props;
    const self = this;
    const loader = <div className="loader-button"></div>;
    let shipperUrl = '/user-profile/' + this.props.quesAns.shipperId;
    let carrierUrl = '/user-profile/' + this.props.quesAns.carrierId;
    quesAns.carrierImgUrl = quesAns.carrierImgUrl || "../../public/images/user_placeholder.svg";
    info.profileImgUrl = info.profileImgUrl || "../../public/images/user_placeholder.svg";

    return (
      <div className="question-answer">
        { this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        <ConfirmDeleteComponent onConfirmCallback = {this.flagQuestion} closePopupCallback = {this.hideConfirmBox}header = "Confirm" description = "Are you sure that you want to flag this question?" popupState = {this.state.showConfirmBox}/>
        <div className="question">
          <Link to={carrierUrl}>
            <div className="shipper-img" style={{"backgroundImage": 'url("' + quesAns.carrierImgUrl+ '")'}}></div>
          </Link>
          <div className="shipper-name">
              {quesAns.carrierName}
          </div>
          <div className="shipper-created-date">
              {moment(quesAns.lut).fromNow()}
          </div>
          <div className="triangle"></div>
          <div className="question-content">
              {quesAns.question}
          </div>
          {
            (self.props.userId == info.userId) && !(quesAns.isQuestionFlagged) && <div className = "unflagged-img" onClick = {() => this.showConfirmBox(quesAns.questionId)}></div>
          }
          {
            (self.props.userId == info.userId) && (quesAns.isQuestionFlagged) && <div className = "unflagged-img flagged"></div>
          }
        </div>
          {
              !quesAns.answer && (self.props.userId == info.userId) && <div className="answer-section">
             {
               self.state.showSubmit && <input autoFocus onChange = {self.changeHandler}type = "text" value = {self.state.answer} className="input" placeholder="Answer the question" />
             }
             {
               !self.state.showSubmit && <button onClick = {self.showSubmit}className="btn green">Answer</button>
             }
             {
               self.state.answer && <button onClick = {self.answerQuestion}className="btn green">{this.state.ajaxInProgress? loader : 'Submit'}</button>
             }
             {
               self.state.showSubmit && <button onClick = {self.showSubmit}className="btn orange margin">Cancel</button>
             }
             </div>
          }
          {
              quesAns.answer && <div className="question answer">
              <Link to={shipperUrl}>
                <div className="shipper-img" style={{"backgroundImage": 'url("' + info.profileImgUrl+ '")'}}></div>
              </Link>

                <div className="shipper-name">
                    {info.name}
                </div>
                <div className="triangle"></div>
                <div className="question-content">
                    {quesAns.answer}
                </div>
              </div>
          }
        </div>
    )
  }
}


export default class ShipperInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count : 10 ,
      offset : 0,
      ajaxInProgress : false,
      question :"",
      initialQAlength : this.props.questionAns.length
    }
  }
  componentWillReceiveProps(newProps){
    this.setState({
      initialQAlength : newProps.questionAns.length
    })
  }
  getMoreQuestionAnsweres = ()=>{
    let length = this.state.count;
    if(this.state.initialQAlength < length)
      length = this.state.initialQAlength
    const paramObj = {
      count : this.state.count ,
      offset : this.state.offset + length,
      shipmentId : this.props.questionAns[0].shipmentId
    }
  this.setState({
    offset :  this.state.offset + this.state.count,
    ajaxInProgress : true
  })
  this.props.shipmentActions.getAllQuestionAnswere(paramObj).then(() => {
    this.setState({ajaxInProgress: false, error: ''});
  }, (errorRes) => {
    if (errorRes.error === CONSTANTS.sessionInvalid) {
      this.setState({ajaxInProgress: false});
      props.authActions.sessionValid(false);
      cookies.delete('_sd');
      return ;
    }
    this.setState({isLoading: false, error: errorRes.error})
  });
  }
  changeHandler = (e) =>{
    this.setState({
      question : e.target.value
    })
  }
  submit = (e) =>{
    e.preventDefault();
    if(this.state.question != "")
    {
      let paramObj = {
        question : this.state.question,
        shipmentId : this.props.shipmentId
      }
      this.setState({
        ajaxInProgress : true
      })
      this.props.shipmentActions.askAQuestion(paramObj).then(() => {
        this.setState({ajaxInProgress: false, error: ''});
        this.props.refreshShipmentDetails();
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          this.setState({ajaxInProgress: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({isLoading: false, error: errorRes.error})
      });
    }
  }
  render() {
    const {info,questionAns,userId,shipmentDetails} = this.props;
    const self = this;
    let totalCount = this.props.totalCount;
    let questionAnsCount = questionAns.length;
    let showLoadMore = questionAnsCount < totalCount ? (true) :false
    let profileImgUrl = info ? info.profileImgUrl : "../../public/images/user_placeholder.svg";
    let shipperUrl = '/user-profile/' + this.props.shipmentDetails.shipperId;
    const loader = <div className="loader-button"></div>;
    let shipmentInfomation = {} , isBlocked = false;
    if("isBlocked" in shipmentDetails)
      isBlocked = shipmentDetails.isBlocked;
    if(shipmentDetails.isShipper && shipmentDetails.shipmentStatus >= 4)
    {
      shipmentInfomation.title = "Carrier";
      shipmentInfomation.profileImgUrl = shipmentDetails.carrierInfo.profileImgUrl || "../../public/images/user_placeholder.svg";
      shipmentInfomation.averageRating = shipmentDetails.carrierInfo.averageRating;
      shipmentInfomation.name = shipmentDetails.carrierInfo.name;
      shipmentInfomation.totalNoOfRatings = shipmentDetails.carrierInfo.totalNoOfRatings;
      shipmentInfomation.isVerified = shipmentDetails.carrierInfo.isVerified;
      shipmentInfomation.isVerified = shipmentDetails.carrierInfo.isVerified;
      shipmentInfomation.url = '/user-profile/' + shipmentDetails.carrierInfo.userId;
    }else{
      shipmentInfomation.title = "Shipper";
      shipmentInfomation.profileImgUrl = shipmentDetails.shipperInfo.profileImgUrl || "../../public/images/user_placeholder.svg";
      shipmentInfomation.averageRating = shipmentDetails.shipperInfo.averageRating;
      shipmentInfomation.name = shipmentDetails.shipperInfo.name;
      shipmentInfomation.totalNoOfRatings = shipmentDetails.shipperInfo.totalNoOfRatings;
      shipmentInfomation.isVerified = shipmentDetails.shipperInfo.isVerified;
      shipmentInfomation.isVerified = shipmentDetails.shipperInfo.isVerified;
      shipmentInfomation.url = '/user-profile/' + shipmentDetails.shipperInfo.userId;
    }
    return (
      <div id = "shipper-info">
        <div className="info-section">
        { !isBlocked &&
            <div className = "info-content">
             <div className="heading">
               {shipmentInfomation.title}
             </div>
             <div className="shipper-details-wrap">
               <Link to={shipmentInfomation.url}>
                 <div className="shipper-img" style={{"backgroundImage": 'url("' + shipmentInfomation.profileImgUrl+ '")'}}></div>
               </Link>

               <div className="name">
                 {shipmentInfomation.name}
                 <MediaQuery query='(max-width: 767px)'>
                   <Rating rating = {shipmentInfomation.averageRating} ratingSize="rating-size14"/>
                   <div className="rating-number"> ({shipmentInfomation.totalNoOfRatings})</div>
                 </MediaQuery>
               </div>
               <div className="shipper-verification">
                 {shipmentInfomation.isVerified &&<div  className="account-verified-elm"></div>}
               </div>
               <MediaQuery query='(min-width: 767px)'>
                 <div className="shipper-rating">
                   <Rating rating = {shipmentInfomation.averageRating} ratingSize="rating-size14"/>
                   <div className="rating-number"> ({shipmentInfomation.totalNoOfRatings})</div>
                 </div>
               </MediaQuery>
             </div>
           </div>
         }
         {
           info && userId != info.userId && shipmentDetails.shipmentStatus!=9 && !shipmentDetails.isReceiver && <div>
             <div className="border-div"></div>
             <div className="heading">
               Questions
             </div>
             <form onSubmit = {this.submit}>
               <div className="question-input">
                 <input value = {this.state.question}
                        onChange = {this.changeHandler}
                        type="text"
                        placeholder="Ask a Question"
                        className="input"/>
               </div>
               <div className="button-section">
                 <button className={this.state.question == "" ? "btn green disabled" : "btn green"}> {this.state.ajaxInProgress? loader : 'Submit'}</button>
               </div>
             </form>
           </div>
         }
        </div>
        {
          questionAns.length > 0 && <div className="question-answer-section">
             {
                questionAns.map(function(quesAns,index){
                   return(
                       <MessageComponent info = {info} key = {index} userId = {self.props.userId}quesAns={quesAns} shipmentActions = {self.props.shipmentActions}/>
                         )
                 })
             }
             {
               showLoadMore && <div className="load-more-section">
                   <button onClick = {this.getMoreQuestionAnsweres} className="btn green">{this.state.ajaxInProgress? loader : 'Load more'}</button>
               </div>
             }
           </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// app/shipment/shipperInfo/shipperInfo.jsx